if (!customElements.get('video-loader')) {
  customElements.define('video-loader', class VideoLoader extends HTMLElement {
    constructor() {
      super();
      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
        root: null, // Use the viewport as the root
        threshold: 0.5, // Trigger when 50% of the element is visible
      });
    }

    connectedCallback() {
      this.observeVideos();
    }

    // Define a function to observe videos within the custom element and load them when they become visible
    observeVideos() {
      const videos = this.querySelectorAll('video');
      videos.forEach((video) => {
        this.intersectionObserver.observe(video);
      });
    }

    // Handle the intersection changes (when videos become visible/invisible)
    handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const sources = video.querySelectorAll("source[data-src]");
          sources.forEach((source) => {
            source.src = source.getAttribute("data-src");
          });
          video.load();
          // Unobserve the video once it's loaded
          observer.unobserve(video);
        }
      });
    }

    // Clean up the Intersection Observer when the element is removed from the DOM
    disconnectedCallback() {
      this.intersectionObserver.disconnect();
    }
  });
}
